'use client';


import { TabItemProps } from './types';
import { useContext } from 'react';
import AlgonomyContext, { AlgonomyContextState } from '@/context/SearchResultsContext';
import clsx from 'clsx';

import styles from './TabItem.module.css';

const TabItem: React.FC<TabItemProps> = ({ label, found, name, activeTab, idx }) => {
  const { handleChangeTab } = useContext(AlgonomyContext) as AlgonomyContextState;

  return (
    <div
      data-testid={`tab-item-${name}${idx}`}
      className={clsx(styles.tabItem, {
        [styles.tabItemActive]: activeTab ? activeTab === name : idx === 0,
      })}
      onClick={() => handleChangeTab(name)}
    >
      {`${label} (${found})`}
    </div>
  );
};

export default TabItem;
